import React from 'react';
import { CloseIcon } from '@chakra-ui/icons';
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Heading,
  HStack,
  IconButton,
  useMediaQuery,
} from '@chakra-ui/react';

import APP_CONFIG from '@/app.config';

import DescomplicaIcon from '../../../../../assets/svg/descomplica-icon.svg';

import DrawerItems from './drawer-items';

type CloseButtonProps = {
  isOpen: boolean;
  onClose: () => void;
};

type NavDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

const CloseButton = ({ isOpen, onClose }: CloseButtonProps): React.ReactElement | null => {
  // eslint-disable-next-line unicorn/no-null
  if (!isOpen) return null;

  return (
    <IconButton
      variant='ghost'
      size='md'
      icon={<CloseIcon />}
      aria-label='Fechar menu'
      onClick={onClose}
    />
  );
};

const NavigationDrawer = ({ isOpen, onClose }: NavDrawerProps): React.ReactElement => {
  const [isSmallerThan768] = useMediaQuery('(max-width: 768px)');

  return (
    <Drawer
      placement='left'
      size={isSmallerThan768 ? 'full' : 'sm'}
      onClose={onClose}
      isOpen={isOpen}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerHeader borderBottomWidth='1px'>
          <Flex justifyContent='space-between'>
            <HStack>
              <Box w='32px' h='32px'>
                <DescomplicaIcon />
              </Box>
              <Heading size='md'>{APP_CONFIG.title}</Heading>
            </HStack>
            <CloseButton isOpen={isOpen} onClose={onClose} />
          </Flex>
        </DrawerHeader>
        <DrawerBody>
          <DrawerItems isOpen={isOpen} onClose={onClose} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default NavigationDrawer;
